// extracted by mini-css-extract-plugin
export default {"spin_white":"loader_spin_white__Kupnh"};